import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { fill, useEnabled, useSeo, useTexts } from "@/lib/layout";
import { StoryFeed, useArticleFeed } from "@/components/site/StoryFeed";
import NotFound from "@/pages/NotFound";

export default function Listing({ mode }) {
  const { tag } = useParams();
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [text, setText] = useState(q);
  const feed = useArticleFeed(mode, mode === "tag" ? { tag } : { q });
  const { seo } = useSeo();
  const t = useTexts(mode);
  const enabled = useEnabled(mode);
  if (!enabled) return <NotFound />;
  const title = mode === "tag" ? `#${tag}` : q ? `«${q}»` : t.title;
  return (
    <div className="wrap pt-10 md:pt-14" data-testid={`listing-${mode}`}>
      <Seo
        title={mode === "tag" ? fill(t.seo_title_template, { tema: tag }) : `${t.title || ""} ${q}`.trim()}
        description={mode === "tag" ? fill(t.seo_description_template, { tema: tag }) : t.seo_description}
        noindex={mode === "search" || seo.index_tags === false}
      />
      <header className="border-b-2 border-foreground pb-8 mb-12">
        <p className="kicker text-primary">{t.kicker}</p>
        <h1 className="font-display font-black tracking-[-0.03em] text-5xl sm:text-6xl mt-2 break-words" data-testid="listing-title">{title}</h1>
        {mode === "search" && (
          <form onSubmit={(e) => { e.preventDefault(); setParams(text.trim() ? { q: text.trim() } : {}); }} className="mt-8 flex items-center gap-3 border-b border-border pb-3 max-w-2xl">
            <Search className="h-5 w-5 text-muted-foreground" />
            <input value={text} onChange={(e) => setText(e.target.value)} placeholder={t.placeholder} className="flex-1 bg-transparent font-display text-2xl outline-none" data-testid="search-page-input" />
            <button className="kicker text-primary" data-testid="search-page-submit">{t.button}</button>
          </form>
        )}
      </header>
      {(mode === "tag" || q) && <StoryFeed feed={feed} empty={t.empty} />}
    </div>
  );
}
